import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-50de159c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "successItem" }
const _hoisted_2 = { class: "successItemInner" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "point" }, "✓", -1))
const _hoisted_4 = { class: "caption" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.caption), 1)
    ])
  ]))
}